// Relative-time label derived fresh from a real timestamp - never stored,
// so it can't go stale independently of the underlying data. Shared by
// DevicesPage and SystemHealthPage.
export function formatRelative(timestamp, nowMs = Date.now()) {
  if (!timestamp) return 'Inconnu';
  const seconds = Math.max(0, Math.round((nowMs - new Date(timestamp).getTime()) / 1000));
  if (seconds < 5) return "À l'instant";
  if (seconds < 60) return `Il y a ${seconds} s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `Il y a ${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `Il y a ${hours} h`;
  return `Il y a ${Math.floor(hours / 24)} j`;
}
